module.exports = __webpack_public_path__ + "static/media/cover.31fc5efa.png";